// Reproductor de video inline (Vimeo/YouTube) sin carrusel.
// Markup esperado:
//   <div class="inline-video" data-platform="vimeo|youtube" data-video-id="...">
//     ...poster + button.inline-video__btn...
//     <div class="inline-video__player">
//       <div class="inline-video__player-host"></div>
//       <div class="inline-video__controls">
//         .cs-play (con .cs-icon-play / .cs-icon-pause)
//         .cs-seek (input range)
//         .cs-time (span)
//         .cs-mute (con .cs-icon-sound / .cs-icon-muted)
//       </div>
//     </div>
//   </div>
const InlineVideo = (()=>{

    let active = null;

    const fmt = (s)=>{
        const m   = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    };

    const fillSeek = (input, pct)=>{
        input.style.background = 'linear-gradient(to right, #0094FF ' + pct + '%, rgba(255,255,255,0.3) ' + pct + '%)';
    };

    const waitFor = (cond, cb)=>{
        if(cond()){ cb(); return; }
        const t = setInterval(()=>{
            if(cond()){ clearInterval(t); cb(); }
        }, 80);
    };

    const closeActive = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        try {
            if(active.platform === 'vimeo' && active.player) active.player.unload();
            else if(active.platform === 'youtube' && active.player) active.player.destroy();
        } catch(_){}
        const host = active.container.querySelector('.inline-video__player-host');
        if(host){ host.innerHTML = ''; host.classList.remove('yt-host'); }
        active.container.removeAttribute('data-state');
        active = null;
    };

    const updatePlayUI = ()=>{
        if(!active) return;
        active.controls.iconPlay.style.display  = active.isPlaying ? 'none' : '';
        active.controls.iconPause.style.display = active.isPlaying ? '' : 'none';
    };

    const updateMuteUI = ()=>{
        if(!active) return;
        active.controls.iconSound.style.display = active.isMuted ? 'none' : '';
        active.controls.iconMuted.style.display = active.isMuted ? '' : 'none';
    };

    const startProgress = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        active.progressTimer = setInterval(()=>{
            if(!active || active.seeking || !active.player) return;
            try {
                if(active.platform === 'vimeo'){
                    active.player.getCurrentTime().then((cur)=>{
                        if(!active) return;
                        active.player.getDuration().then((dur)=>{
                            if(!active || !dur) return;
                            const pct = (cur / dur) * 100;
                            active.controls.seek.value = pct;
                            fillSeek(active.controls.seek, pct);
                            active.controls.time.textContent = fmt(cur) + ' / ' + fmt(dur);
                        });
                    });
                } else {
                    const cur = active.player.getCurrentTime();
                    const dur = active.player.getDuration();
                    if(!dur) return;
                    const pct = (cur / dur) * 100;
                    active.controls.seek.value = pct;
                    fillSeek(active.controls.seek, pct);
                    active.controls.time.textContent = fmt(cur) + ' / ' + fmt(dur);
                }
            } catch(_){}
        }, 400);
    };

    const stopProgress = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        active.progressTimer = null;
    };

    const togglePlay = ()=>{
        if(!active || !active.player) return;
        try {
            if(active.platform === 'vimeo'){
                active.isPlaying ? active.player.pause() : active.player.play();
            } else {
                active.isPlaying ? active.player.pauseVideo() : active.player.playVideo();
            }
        } catch(_){}
    };

    const toggleMute = ()=>{
        if(!active || !active.player) return;
        active.isMuted = !active.isMuted;
        try {
            if(active.platform === 'vimeo'){
                active.player.setVolume(active.isMuted ? 0 : 1);
            } else {
                active.isMuted ? active.player.mute() : active.player.unMute();
            }
        } catch(_){}
        updateMuteUI();
    };

    const onSeek = ()=>{
        if(!active || !active.player) return;
        const pct = parseFloat(active.controls.seek.value) / 100;
        try {
            if(active.platform === 'vimeo'){
                active.player.getDuration().then((dur)=>{
                    if(active && active.player) active.player.setCurrentTime(dur * pct);
                });
            } else {
                active.player.seekTo(active.player.getDuration() * pct, true);
            }
        } catch(_){}
    };

    const openVideo = (container)=>{
        if(active && active.container !== container) closeActive();
        if(active && active.container === container) return;

        const platform = container.getAttribute('data-platform');
        const id       = container.getAttribute('data-video-id');
        const host     = container.querySelector('.inline-video__player-host');
        if(!platform || !id || !host) return;

        const controls = {
            play:      container.querySelector('.cs-play'),
            mute:      container.querySelector('.cs-mute'),
            seek:      container.querySelector('.cs-seek'),
            time:      container.querySelector('.cs-time'),
            iconPlay:  container.querySelector('.cs-icon-play'),
            iconPause: container.querySelector('.cs-icon-pause'),
            iconSound: container.querySelector('.cs-icon-sound'),
            iconMuted: container.querySelector('.cs-icon-muted'),
        };

        container.setAttribute('data-state', 'playing');
        host.innerHTML = '';

        active = {
            player: null,
            platform: platform,
            container: container,
            controls: controls,
            isPlaying: false,
            isMuted: false,
            seeking: false,
            progressTimer: null
        };

        const wireBtn = (btn, handler)=>{
            const fresh = btn.cloneNode(true);
            btn.parentNode.replaceChild(fresh, btn);
            fresh.addEventListener('click', handler);
            return fresh;
        };
        controls.play = wireBtn(controls.play, togglePlay);
        controls.mute = wireBtn(controls.mute, toggleMute);
        controls.iconPlay  = controls.play.querySelector('.cs-icon-play');
        controls.iconPause = controls.play.querySelector('.cs-icon-pause');
        controls.iconSound = controls.mute.querySelector('.cs-icon-sound');
        controls.iconMuted = controls.mute.querySelector('.cs-icon-muted');

        const freshSeek = controls.seek.cloneNode(true);
        controls.seek.parentNode.replaceChild(freshSeek, controls.seek);
        controls.seek = freshSeek;
        controls.seek.addEventListener('mousedown',  ()=>{ if(active) active.seeking = true; });
        controls.seek.addEventListener('touchstart', ()=>{ if(active) active.seeking = true; }, { passive: true });
        controls.seek.addEventListener('input',  ()=>{ fillSeek(controls.seek, controls.seek.value); });
        controls.seek.addEventListener('change', ()=>{ if(active) active.seeking = false; onSeek(); });

        if(platform === 'vimeo'){
            const iframe = document.createElement('iframe');
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&controls=0&background=0';
            host.appendChild(iframe);

            waitFor(()=> window.Vimeo && window.Vimeo.Player, ()=>{
                if(!active || active.container !== container) return;
                active.player = new window.Vimeo.Player(iframe);
                active.player.on('play',  ()=>{ if(active){ active.isPlaying = true;  updatePlayUI(); startProgress(); } });
                active.player.on('pause', ()=>{ if(active){ active.isPlaying = false; updatePlayUI(); stopProgress(); } });
                active.player.on('ended', ()=>{ if(active){ active.isPlaying = false; updatePlayUI(); stopProgress(); } });
                active.isPlaying = true;
                updatePlayUI();
                updateMuteUI();
            });
        } else if(platform === 'youtube'){
            host.classList.add('yt-host');
            const div = document.createElement('div');
            host.appendChild(div);

            waitFor(()=> window.YT && window.YT.Player, ()=>{
                if(!active || active.container !== container) return;
                active.player = new window.YT.Player(div, {
                    videoId: id,
                    playerVars: { autoplay: 1, controls: 0, modestbranding: 1, rel: 0, fs: 0, playsinline: 1 },
                    events: {
                        onReady: function(){
                            if(active){ active.isPlaying = true; updatePlayUI(); updateMuteUI(); startProgress(); }
                        },
                        onStateChange: function(e){
                            if(!active || !window.YT) return;
                            const S = window.YT.PlayerState;
                            if(e.data === S.PLAYING){
                                active.isPlaying = true;  updatePlayUI(); startProgress();
                            } else if(e.data === S.PAUSED || e.data === S.ENDED){
                                active.isPlaying = false; updatePlayUI(); stopProgress();
                            }
                        }
                    }
                });
            });
        }
    };

    const wireTriggers = ()=>{
        document.querySelectorAll('.inline-video .inline-video__btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const container = btn.closest('.inline-video');
                if(container) openVideo(container);
            });
        });
    };

    return {
        init: function(){
            try {
                if(!document.querySelector('.inline-video')) return;
                wireTriggers();
            } catch(_){}
        }
    };

})();

const getInlineVideoHandlers = ()=>{
    InlineVideo.init();
};

export {
    getInlineVideoHandlers
};
